// extracted by mini-css-extract-plugin
module.exports = {"SideAdBanner":"SideAdBanner_SideAdBanner__-W0Ik","advertisement":"SideAdBanner_advertisement__MBJIW"};